<div class="chart_container">
    <canvas #doughnutChartWrapper> </canvas>
</div>
